import { Box, Typography } from '@mui/material';
import useFetch from '../../../api/useFetch';
import { BillingPosition } from '../../../components/special/BillingPosition';
import Pagination from '../../../components/special/Pagination';
import { useState } from 'react';
import { NewBillingPosition } from '../../../components/new/NewBillingPosition';
import Loader from '../../../components/special/Loader';
import ExoDialog from '../../../components/exo/ExoDialog';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';

import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../../components/special/updateOrCreate';

export const BillingPositionsTab = ({ project }) => {
  const { t } = useTranslation();
  const { apiData, setApiData } = useFetch(
    `project-positions?projectId[eq]=${project.id}`
  );
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);

  function handlePosition(data) {
    handleCloseForm();
    setApiData(updateOrCreate(apiData, data.data));
  }

  function handleCloseForm() {
    setOpen(false);
    setEdit(null);
  }

  function handleDelete(element) {
    const newPositions = apiData.data.filter((obj) => obj.id !== element.id);
    setApiData({ ...apiData, data: newPositions });
  }

  return (
    <Box className="flex flex-col justify-between gap-2 overflow-hidden w-full relative">
      <Loader active={isLoading || !apiData} />
      <Box className="flex flex-col gap-2 h-full overflow-y-auto w-full">
        <Typography className=" opacity-50 max-w-[600px]">
          {t(
            'Work packages can be billed via the billable positions. The time incurred or a flat rate amount can be invoiced via the position. Here, you can choose between a detailed, daily or a rough summary.'
          )}
        </Typography>
        {apiData?.data.map((pos) => (
          <BillingPosition key={pos.id} position={pos} onEdit={setEdit} />
        ))}
        <ProjectAddElementButton onClick={() => setOpen(true)} size="small" />
      </Box>
      <Pagination
        data={apiData}
        setData={setApiData}
        setLoading={setIsLoading}
      />

      <ExoDialog
        open={open || Boolean(edit)}
        onClose={handleCloseForm}
        limitWidth
      >
        <NewBillingPosition
          projectId={project.id}
          onCreate={handlePosition}
          onUpdate={handlePosition}
          startData={edit}
          onClose={handleCloseForm}
          onDelete={handleDelete}
        />
      </ExoDialog>
    </Box>
  );
};
